/** @jsx jsx */
import { jsx } from "theme-ui"
import PropTypes from "prop-types"

const Facebook = ({ className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="33"
      fill="none"
      viewBox="0 0 17 33"
      className={className}
    >
      <path
        fill="#fff"
        d="M4.939 32.97V18.224H0v-5.86h4.939V7.747C4.939 2.73 8.004 0 12.479 0c2.145 0 3.986.161 4.521.232v5.241h-3.104c-2.434 0-2.904 1.16-2.904 2.853v4.038h5.493l-.754 5.86h-4.739V32.97"
      ></path>
    </svg>
  )
}

Facebook.propTypes = {
  className: PropTypes.string,
}

export default Facebook
